import { API_URL } from '../lib/api';

export function useCustomerPortal() {
  const openCustomerPortal = async () => {
    const response = await fetch(`${API_URL}/api/auth/customer/portal`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      throw new Error('Failed to open customer portal');
    }

    const data = await response.json();
    if (!data.url) {
      throw new Error('No portal URL available');
    }
    window.open(data.url, '_blank');
  };

  return { openCustomerPortal };
}
